import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { DomQueryModule, DomQueryService } from '../dom-query';
import { GoogleMapNormalizeService } from './google-map-normalize.service';
import { GOOGLE_MAPS_API_CONFIG_TOKEN } from './google-maps-settings.config';
import { GoogleMapsSettingsRepository } from './google-maps-settings.repository.http';
import { GoogleMapsSettingsService } from './google-maps-settings.service';

@NgModule({
  imports: [CommonModule],
})
export class GoogleMapsSettingsModule {
  static forRoot(apiKey: string): ModuleWithProviders<GoogleMapsSettingsModule> {
    return {
      ngModule: GoogleMapsSettingsModule,
      providers: [
        { provide: GOOGLE_MAPS_API_CONFIG_TOKEN, useValue: { apiKey } },
        GoogleMapsSettingsRepository,
        GoogleMapsSettingsService,
        GoogleMapNormalizeService,
        DomQueryModule,
        DomQueryService,
      ],
    };
  }
}
